import React, { useEffect, useState } from 'react';
import { BrowserRouter   } from 'react-router-dom';
import AppRoutes from './routes';
import KioskSessionGuard from './components/Kiosk/KioskSessionGuard';
import './App.css';
import { AxiosInterceptor } from './services/config';
import MaintenanceMode from './routes/MaintananceMode';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';
import * as serviceWorker from "./serviceWorker"; // CRA generated file
import VersionUpdateModal from './VersionUpdateModal';

// import { ToastProvider } from './context/ToaxtContext';

function App() {
    const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

   useEffect(() => {
    // listenForReloadSignal();
    serviceWorker.register({
      onUpdate: registration => {
        setShowUpdateModal(true);
        setWaitingWorker(registration.waiting);
      }
    });
  }, []);

  const handleReload = () => {
    if (waitingWorker) {
      // waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      // waitingWorker.addEventListener('statechange', e => {
      //   if (e.target.state === 'activated') {
          // broadcastReload();
          window.location.reload();
          
        // }
      // });
    }
  };
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;
  if (isMaintenanceMode==='true') {
    return <MaintenanceMode />;
  }
  return(
    <BrowserRouter>
        <AxiosInterceptor>
            <I18nextProvider i18n={i18n}>
          <VersionUpdateModal
            isOpen={showUpdateModal}
            onConfirm={handleReload}
            onCancel={() => setShowUpdateModal(false)}
          />
          <KioskSessionGuard>
            <AppRoutes />
          </KioskSessionGuard>
            </I18nextProvider>
          </AxiosInterceptor>
    </BrowserRouter>
  )
}

// serviceWorkerRegistration.register();


export default App;